// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* ********************************* *\
            Imports
\* ********************************* */
import Vue from 'vue'
import App from './App'
import { router } from './router'
import { store } from './store'

// Extra Vue Complied
import './less/main.less'
import breadcrumbs from './components/foundation/breadcrumbs.vue'
import addressComponent from './components/foundation/address.vue'
import icon from './components/foundation/icon.vue'
import save from './components/foundation/save.vue'

// AWS Amplify - Imports
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsExports from './aws-exports'

// Font Awesome
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* ********************************* *\
     Global Component Registration
\* ********************************* */
Vue.component('addressComponent', addressComponent)
Vue.component('breadcrumbs', breadcrumbs)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('icon', icon)
Vue.component('save', save)

/* ********************************* *\
          Configuration
\* ********************************* */
// AWS Amplify
Amplify.configure(awsExports)

/* ********************************* *\
          Init Components
\* ********************************* */
Vue.use(AmplifyPlugin, AmplifyModules)

library.add(fas, far)
dom.watch()

/* ********************************* *\
          Global Functions
\* ********************************* */
let handleOutsideClick
Vue.directive('click-outside-menu', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

Vue.config.productionTip = process.env.DEBUG_MODE

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: store,
  router: router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js